import React, { useEffect, useState } from "react";
import { leaveApi } from "../../services/leaveApi";
import { StatusBadge } from "../../components/StatusBadge";
import { PageHelpBanner } from "../../components/PageHelpBanner";
import { useLocalization } from "../../hooks/useLocalization";

export default function MyLeaveHistoryPage() {
  const { t } = useLocalization();
  const [ledger, setLedger] = useState([]);
  useEffect(() => { leaveApi.myLedger().then((r) => setLedger(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-4" data-testid="my-leave-history-page">
      <PageHelpBanner pageKey="my-leave-history" title={t("pageHelp.defaultTitle")}>
        <p>{t("pageHelp.myLeaveHistory")}</p>
      </PageHelpBanner>
      <h2 className="text-xl font-bold tracking-tight text-gray-900">{t("myLeaveHistory.title")}</h2>
      <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
        {ledger.map((tx) => (
          <div key={tx.id} className="p-4 flex items-center justify-between" data-testid={`my-ledger-row-${tx.id}`}>
            <div>
              <StatusBadge status={tx.type} />
              <p className="text-xs text-gray-500 mt-1">{tx.effective_date} {tx.reason ? `· ${tx.reason}` : ""}</p>
            </div>
            <p className={`font-semibold ${tx.days >= 0 ? "text-emerald-600" : "text-red-600"}`}>{tx.days > 0 ? "+" : ""}{tx.days}</p>
          </div>
        ))}
        {ledger.length === 0 && <p className="p-6 text-center text-sm text-gray-500" data-testid="no-my-ledger-rows">{t("myLeaveHistory.noTransactions")}</p>}
      </div>
    </div>
  );
}
